import React, { useState, Fragment } from "react"
import PopUpScreen from "../../component/popUpScreen/popUpScreen"
import { Accordion, AccordionTab } from 'primereact/accordion';
import { useDispatch, useSelector } from "react-redux";
import IconInputText from "../../component/iconInputText/iconInputText";
import TableComponent from "../../component/Tables/tableComponent";
import FormDropdown from "../../component/dropdown/formDropdown";
import { MultiSelect } from "primereact/multiselect";
import { RESET_FORM_VALUE, SET_FORM_OPTION_OBJECT_VALUE, SET_FORM_OPTION_OBJECTS_OBJECT_VALUE } from "../../redux/dataAsset/dataAsset.type";
import { Button } from "primereact/button";
import { saveAndDoLater, submitTempCDESelection } from "../../redux/dataAsset/dataAsset.action";

function SelectedCdePopUp({ changeDetail, dataAssetId, onHide }) {
    let dispatch = useDispatch()
    const { formData, apiData } = useSelector((state) => state.dataAsset)
    const [searchVal, setSearchVal] = useState("")
    const getTableColumns = () => {
        return [
            { field: "ruleType", header: "Rule Type" },
            { field: "name", header: "Dimension", body: (rowData) => bodyTemplate(rowData, "dropdown", "dimension", "name") },
            { field: "checkName", header: "DQ Rule Check", body: (rowData) => bodyTemplate(rowData, "dropdown", "check_type", "check_name") },
            { field: "ruleName", header: "Rule Name" },
            { field: "rule_description", header: "Rule Description" },
            { field: "expression", header: "Expresion" },
        ]
    }
    const bodyTemplate = (rowData, type, field, optionField) => {

        switch (field) {
            case "dimension":
                return <FormDropdown style={{ width: "100%", margin: "4px 0px" }} options={formData[field].options} placeholder="" optionLabel={optionField} name={field} value={{ id: rowData.id, name: rowData.name }} required={false} onChange={(e) => {
                    dispatch({
                        type: SET_FORM_OPTION_OBJECTS_OBJECT_VALUE,
                        payload: {
                            formField: "cdeform",
                            id: rowData.attributeId,
                            idField: "attributeId",
                            subId: rowData.id,
                            subIdField: "id",
                            optionField: "dimension",
                            value: e.value 
                        }
                    })

                }} />
            case "check_type":
                return <FormDropdown style={{ width: "100%", margin: "4px 0px" }} options={
                    formData[field].options.filter((val) => val.dimension_id === rowData.id)[0].checks.column_level} placeholder="" optionLabel={optionField} name={field} value={{
                        check_id: rowData.check_id,
                        check_name: rowData.check_name,
                        rule_description: rowData.rule_description,
                        dataAssetChecks :"Column Level Check"
                    }} required={false} onChange={(e) => {
                        dispatch({
                            type: SET_FORM_OPTION_OBJECTS_OBJECT_VALUE,
                            payload: {
                                formField: "cdeform",
                                id: rowData.attributeId,
                                idField: "attributeId",
                                subId: rowData.id,
                                subIdField: "id",
                                optionField: "dimension",
                                value: {ruleType: "Standard", expression:"NA",ruleName: apiData.assetSummary.data.data_asset_name + "_" + rowData.attributeName + "_" + e.value.check_name, ...e.value, ...rowData }
                                // value: {check_name: "", ruleType: "Standard", expression: "", ruleName: apiData.assetSummary.data.data_asset_name + "_" + rowData.attributeName + "_", ...e.value}
                            }
                        })

                    }} />
            default: console.warn(type + " is not included")
        }

    };
    const getUpdatedCDE = () => {
        if (searchVal === "") {
            return formData.cdeform.options
        } else {
            return formData.cdeform.options.filter((val) => val.attributeName.toLowerCase().includes(searchVal.toLowerCase()))

        }


    }
    return (
        <PopUpScreen header={
            <div className="grid" style={{ padding: "0px", margin: "0px" }}>
                <div className="col-8" style={{ padding: "0px", margin: "0px", marginTop: "2%" }}>
                    <Fragment>Selected CDEs</Fragment>

                </div>
                <div className="col-4" style={{ padding: "0px", margin: "0px", padding: "0px", margin: "0px" }}>
                    <IconInputText iconPosition="left" style={{ width: "100%", marginRight: "10px", height: "40px" }} value={searchVal} onChange={(e) => { setSearchVal(e.target.value) }} iconName="pi-search" placeholderName="Search Columns" />
                </div>
            </div>
        } onHide={() => {
            formData.cdeform.options.map((val) => {
                dispatch({
                    type: SET_FORM_OPTION_OBJECT_VALUE,
                    payload: {
                        formField: "cdeform",
                        id: val.attributeId,
                        idField: "attributeId",
                        optionField: "dimension",
                        value: []
                        // attributeId:val.attributeId
                    }
                })
            })
            onHide()
        }}
            style={{ width: '90%', maxHeight: "90%" }} >

            <Accordion>
                {getUpdatedCDE().map((val) => {
                    return (
                        <AccordionTab key={val.attribute_id} header={
                            <div className="grid" style={{ padding: "0px", margin: "0px" }}>
                                <div className="col-8" style={{ padding: "0px", margin: "0px", alignSelf: "anchor-center" }}>
                                    {val.attribute_name}
                                </div>
                                <div className="col-4" style={{ padding: "0px", margin: "0px" }}>
                                    <MultiSelect name="dimension" style={{ textAlign: "left", width: "100%" }} value={val.dimension.map((val) => {
                                        return { id: val.id, name: val.name }
                                    })} onChange={(e) => {
                                        dispatch({
                                            type: SET_FORM_OPTION_OBJECT_VALUE,
                                            payload: {
                                                formField: "cdeform",
                                                id: val.attributeId,
                                                idField: "attributeId",
                                                optionField: "dimension",
                                                value: e.value
                                                    .map((val1) => {
                                                        return { attributeName: val.attributeName, attributeId: val.attributeId, ...val1 }
                                                    })
                                                // attributeId:val.attributeId
                                            }
                                        })
                                        // changeDetail(e, "multiSelect", e.value)
                                    }
                                    }
                                        options={formData.dimension.options} optionLabel="name" placeholder="Select Dimension" />
                                </div>
                            </div>
                        } >
                            <TableComponent scrollable scrollHeight="100%" checked={false} style={{ width: "100%" }} tableData={val.dimension} columns={getTableColumns()} />
                        </AccordionTab>
                    );
                })}
            </Accordion>
            <div className="grid">
                <div className="col-12" style={{ textAlign: "right" }}>
                    <Button style={{ width: "100px", textAlign: "center", marginRight: "10px" }} outlined label="Cancel" onClick={() => {
                        dispatch({
                            type: RESET_FORM_VALUE
                        })
                        onHide()
                    }} />
                    <Button style={{ width: "100px", textAlign: "center", marginRight: "10px" }} outlined label="Save & Do it later" onClick={() => {
                        dispatch({
                            type: RESET_FORM_VALUE
                        })
                        dispatch(saveAndDoLater(dataAssetId))
                        onHide()
                    }} />
                    <Button onClick={() => {
                        dispatch(submitTempCDESelection(dataAssetId))
                        dispatch({
                            type: RESET_FORM_VALUE
                        })
                        onHide()
                    }
                    }
                        label="Next" icon="pi pi-arrow-right" iconPos="right" />
                </div>
            </div>
        </PopUpScreen>
    )
}

export default SelectedCdePopUp